import React from 'react';
import Modal from '@lwt-helix/modal';
import Loader from '@lwt-helix/loader';
import { Button } from '@lwt-helix/buttons';
import { RadioButton } from './RadioButton';
import { buttonTerms as bt, downloadModalTerms as dmt, downloadFileTypes as dft } from '../../constants';
import { usePDFStore } from '../../store/pdf/store';
import { useFeatureToggles } from '../hooks/featureToggles';
import PropTypes from 'prop-types';
import {
    COVERAGE_AREA_MAX_COUNT_SELECTIONS,
    COVERAGE_AREA_MIN_COUNT_SELECTIONS,
    getRenderedStatusOptions
} from '../../market-dynamics/helpers/optionsSelector';

export const DownloadResultsModal = ({shouldShowAreaSelector}) => {
    const { isPdfUnderConstruction } = useFeatureToggles();
    const {
        downloadModalStatus,
        setDownloadModalStatus,
        areasData,
        handleCheckArea,
    } = usePDFStore((state) => {
        const areasData = state?.areasData || [];
        return ({
            downloadModalStatus: state.downloadModalStatus,
            setDownloadModalStatus: state.setDownloadModalStatus,
            areasData,
            handleCheckArea: state.handleCheckArea,
        });
    });

    const isCsvSelected = downloadModalStatus.fileType === dft.csv;
    const isPdfSelected = downloadModalStatus.fileType === dft.pdf;
    const areasSelected = areasData.filter(area => area.checked).length;
    const isAreasPdfDisabled = shouldShowAreaSelector && isPdfSelected && areasSelected < COVERAGE_AREA_MIN_COUNT_SELECTIONS;

    const handleClose = () => {
        setDownloadModalStatus({
            [dmt.isOpen]: false,
            [dmt.fileType]: dft.csv
        });
    };

    const handleDownload = () => {
        if (downloadModalStatus?.isPDFLoading) return;
        downloadModalStatus.clickAction();
        isCsvSelected && handleClose();
    };

    const handleSelection = (e) => {
        const radioId = e.target.tagName === 'INPUT' && e.target.id;
        if (radioId) setDownloadModalStatus({[dmt.fileType]: radioId.split('-')[0]});
    };

    const handleAreaOptionClick = ({target}) => handleCheckArea(target.id, target.checked);

    const modalButtons = (
        <>
           {isAreasPdfDisabled && (
                <p className='m-0 mr-3 text-danger font-weight-bold'>
                    {dmt.noCoverageAreasSelected}
                </p>
            )}
            <Button
                dataLwtId='modal-btn-cancel'
                color='secondary'
                disabled={downloadModalStatus.isPDFLoading}
                onClick={handleClose}
            >
                {bt.cancel}
            </Button>
            <Button
                dataLwtId='modal-btn-download'
                color='primary'
                disabled={downloadModalStatus.isPDFLoading || isAreasPdfDisabled }
                onClick={handleDownload}
            >
                <div className='d-flex justify-content-center align-items-center xs-spinner'>
                    {downloadModalStatus.isPDFLoading && <Loader />}
                    <p className='pl-2 pr-1 m-0'>{bt.download}</p>
                </div>
            </Button>
        </>
    );

    const selectedAreasDataCount = areasData?.filter(area => area.checked)?.length;
    const pdfReportDescription = <>
        {dmt.pdfDescription}<br/>
        {shouldShowAreaSelector && <small className='coverage-disclaimer'>{dmt.coverageAreaDisclaimer}</small>}
    </>;

    return (
        <Modal
            title={bt.download}
            size='lg'
            show={downloadModalStatus.isPDFLoading || downloadModalStatus.isOpen}
            onClose={!downloadModalStatus.isPDFLoading ? handleClose : () => {}}
            buttons={modalButtons}
        >
            <h5>{dmt.choseType}</h5>
            <div className='d-flex justify-content-between align-items-center mt-2'>
                <RadioButton
                    id="csv-radio"
                    name="fileType"
                    labelText={dmt.csvLabel}
                    description={<>{dmt.csvDescription}{shouldShowAreaSelector && (<><br/>&nbsp;</>)}</>}
                    isChecked={isCsvSelected}
                    handleSelection={handleSelection}
                    disabled={downloadModalStatus.isPDFLoading}
                    shouldShowAreaSelector={shouldShowAreaSelector}
                />
                <RadioButton
                    id="pdf-radio"
                    name="fileType"
                    labelText={dmt.pdfLabel}
                    description={<>{isPdfUnderConstruction ? dmt.comingSoon : pdfReportDescription}</>}
                    isChecked={isPdfSelected}
                    handleSelection={handleSelection}
                    disabled={isPdfUnderConstruction || downloadModalStatus.isPDFLoading}
                />
            </div>
            {isPdfSelected && shouldShowAreaSelector && <div className='mt-3'>
                <h5>{dmt.chooseCoverageArea}</h5>
                <h6>{dmt.coverageAreas} ({selectedAreasDataCount})</h6>
                <div className='areas-select-container'>{getRenderedStatusOptions(
                    areasData,
                    handleAreaOptionClick,
                    areasSelected,
                    COVERAGE_AREA_MAX_COUNT_SELECTIONS
                )}
                </div>
            </div>}
        </Modal>
    );
};

DownloadResultsModal.propTypes = {
    shouldShowAreaSelector: PropTypes.bool
};
